var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStaff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#staff_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  d: "M22.344 36.965a2.833 2.833 0 0 1 2.594-3.054l56.969-4.636a2.833 2.833 0 0 1 3.053 2.595l.774 9.503-62.617 5.095-.773-9.503Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 62,
  height: 42.605,
  x: 22.732,
  y: 34.926,
  stroke: "#36485C",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  rx: 2,
  transform: "rotate(-4.652 22.732 34.926)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "m23.88 45.57 60.955-4.96M41.378 38.787 67.033 36.7M54.53 51.395l11.226-.914M55.385 61.902l25.935-2.111M55.864 67.784l21.592-1.756"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38.843,
  cy: 56.045,
  r: 4.929,
  fill: "#C5CFD9",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  transform: "rotate(-4.652 38.843 56.045)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "staff_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.06 69.326c.643-.052 1.128-.617.997-1.248a9.374 9.374 0 0 0-3.078-5.213 9.24 9.24 0 0 0-6.759-2.196 9.24 9.24 0 0 0-6.316 3.26 9.374 9.374 0 0 0-2.194 5.642c-.027.643.543 1.123 1.185 1.07l8.083-.657 8.083-.658Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.333,
  d: "M48.06 69.326c.643-.052 1.128-.617.997-1.248a9.374 9.374 0 0 0-3.078-5.213 9.24 9.24 0 0 0-6.759-2.196 9.24 9.24 0 0 0-6.316 3.26 9.374 9.374 0 0 0-2.194 5.642c-.027.643.543 1.123 1.185 1.07l8.083-.657 8.083-.658Z",
  mask: "url(#staff_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60768F",
  d: "m81.257 90.384 11.796-10.322c1.664-1.456 2.321-3.427 1.469-4.401l-.001-.001c-.853-.975-2.892-.585-4.556.87L78.169 86.854c-1.663 1.456-2.32 3.426-1.468 4.4v.002c.853.975 2.893.585 4.556-.871Z",
  opacity: 0.35
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "m83.099 92.65 12.002-10.502a4.074 4.074 0 0 0 .384-5.748l-.001-.001a4.071 4.071 0 0 0-5.747-.384L77.735 86.518a4.074 4.074 0 0 0-.383 5.748h0a4.072 4.072 0 0 0 5.747.385Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M77.856 80.587a5.333 5.333 0 1 0-4.523-9.66 5.333 5.333 0 0 0 4.523 9.66Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "m72.106 72.238 7.279 6.898"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "staff_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
})))));
export default SvgStaff;